import type { FC } from 'react';
import NavBarButton from './components/interface/NavBarButton';
import BtnMenu from '@assets/images/iconos-aside-panel-menu.svg';
import BtnORders from '@assets/images/iconos-aside-panel-orders.svg';
import BtnPubli from '@assets/images/iconos-aside-panel-anuncio.svg';
import setupIcon from '@assets/images/iconos-aside-panel-ajustes.svg';
import IconoEstadisticas from '@assets/images/iconos-aside-panel-estadisticas.svg';
import useModules from '@utils/hooks/useModules';
import { ModuleName } from '@utils/constants';
import { useSubscription } from '@pages/Subscriptionsv2/hooks/useSubscriptions';
import { useShouldShowSetup } from '@pages/Setup/hooks/useShouldShowSetup';

const NavBarMobile: FC = () => {
  const { isFreemium } = useSubscription();
  const { hasModule } = useModules();
  const shouldShowSetup = useShouldShowSetup();

  return (
    <div className="fixed w-full bottom-0 left-0 bg-color-gray_light p-0 pt-[2px] flex-1 z-40">
      {/* Contenedor con scroll horizontal */}
      <div className="flex w-full overflow-x-auto overflow-y-hidden pb-2 lg:flex-col navbar-mobile-scroll">
        {/* Wrapper interno para mantener los items juntos */}
        <div className="flex gap-1 px-2 min-w-full justify-evenly lg:flex-col">
          {shouldShowSetup && (
            <NavBarButton
              isExpanded
              to="configuracion-inicial"
              id="configuracion-inicial-link"
              icon={setupIcon}
              label="Configuracion"
            />
          )}

          {(isFreemium || hasModule(ModuleName.ESTADISTICAS)) && (
            <NavBarButton
              isExpanded
              to="estadisticas"
              id="estadisticas-link"
              icon={IconoEstadisticas}
              label="Inicio"
              notIncludedOnCurrentPlan={!hasModule(ModuleName.ESTADISTICAS)}
            />
          )}
          {(isFreemium || hasModule(ModuleName.MENU)) && (
            <NavBarButton
              isExpanded
              to="menu"
              id="menu-link"
              icon={BtnMenu}
              label="Menú"
              notIncludedOnCurrentPlan={!hasModule(ModuleName.MENU)}
            />
          )}
          {(isFreemium || hasModule(ModuleName.HISTORIAL)) && (
            <NavBarButton
              isExpanded
              to="control-pedidos"
              id="control-pedidos-link"
              icon={BtnORders}
              label={'Pedidos'}
              notIncludedOnCurrentPlan={!hasModule(ModuleName.HISTORIAL)}
            />
          )}
          {(isFreemium || hasModule(ModuleName.ANUNCIOS)) && (
            <NavBarButton
              isExpanded
              to="anuncios"
              id="anuncios-link"
              icon={BtnPubli}
              label={'Anuncios'}
              notIncludedOnCurrentPlan={!hasModule(ModuleName.ANUNCIOS)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NavBarMobile;
